<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'fines/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="150"
      >
        <template slot-scope="scope">
          <LicensePlate
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alphaList"
          >
          </LicensePlate>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FULL_NAME')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('FULL_NAME')">
            {{ scope.row.driver.first_name + ' ' + scope.row.driver.last_name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DATE_')"
        width="180"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DATE_')">
            {{ new Date(scope.row.date).toLocaleDateString('fa-IR') }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('PRICE')"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="$t('PRICE')" class="flex">
            <span v-html="$options.filters.numberSeperator(scope.row.cost)">
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TYPE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TYPE')">
            {{ scope.row.type.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('IS_DRIVER_AT_FAULT')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('IS_DRIVER_AT_FAULT')" class="flex">
            <span v-if="scope.row.is_driver_at_fault" class="text-red-700">
              {{ $t('YES') }}
            </span>

            <span v-else class="text-green-700">
              {{ $t('NO') }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :router="{
                name: 'EDIT_FINES',
                id: scope.row.id,
              }"
              :title="$t('FINES')"
              @remove="remove($event)"
              @view="view($event, 'VIEW_FINES')"
              :view="true"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { getFines, removeFine } from '@/api/fines'
import tableFeatures from '@/components/elements/tableFeatures'
import { view } from '@/mixins/viewPage'
import { resetForm } from '@/mixins/resetForm'
import LicensePlate from '@/components/cars/LicensePlate'
import { licenseChars } from '@/api/global'

export default {
  mixins: [view, resetForm],
  data() {
    return {
      tableData: {
        results: [],
      },
      loading: true,
      search: '',
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
    }
  },

  methods: {
    remove(id) {
      removeFine.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('FINES'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData.results = this.tableData.results.filter(
            (table) => table.id !== id
          )
        }
      })
    },
  },
  mounted() {
    getFines.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  components: {
    tableFeatures,
    LicensePlate,
  },
}
</script>
